import type { NonSubscribableProduct } from '$models/NonSubscribableProduct/NonSubscribableProduct';
import type { Product } from '$models/Product/Product';

export function isNotUndefined<T>(value: T | undefined): value is T {
	return value !== undefined;
}

export function isRegularProduct(product: Product | NonSubscribableProduct): product is Product {
	return 'category' in product;
}

export function isNonSubscribableProduct(
	product: Product | NonSubscribableProduct
): product is NonSubscribableProduct {
	return 'price' in product;
}
